import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

import { graphql } from "@repo/graphql-types/gql";

import { PatientList } from "@/components/patient/list/patient-list";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { BottomBarV2 } from "@/components/ui/layout/bottom-bar/bottom-bar-v2";
import { HeaderRoot, HeaderTitle } from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const PatientPageQuery = graphql(/* GraphQL */ `
  query PatientPageQuery {
    ...PatientListQueryFragment
  }
`);

const PatientsPage = (): JSX.Element => {
  const queryResult = useGraphQL(PatientPageQuery);
  const { data } = queryResult;
  const { flags } = Route.useRouteContext();
  const showNewHome = useMemo(() => flags["exibe-nova-home"], [flags]);

  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      <HeaderRoot>
        <HeaderTitle title="Pacientes" align="center" />
      </HeaderRoot>
      <Page className="md:overflow-hidden" sheet={showNewHome}>
        <AsyncDataWrapper {...queryResult}>
          {data ? <PatientList patientList={data} /> : null}
        </AsyncDataWrapper>
      </Page>
      <BottomBarV2 />
    </div>
  );
};

export const Route = createFileRoute("/patients/")({
  component: PatientsPage,
});
